import { CancelToken } from 'axios';

/**
 * This Higher Order Function implements HTTP request cancelling through Axios API.
 * It injects cancelToken into actions payload to be used with API request.
 *
 * NOTE: It is not mutating return value of wrapped function.
 *
 * @example
 *
 *  import { isCancel } from 'axios';
 *
 *  fetchJob: flowRight(
 *     withTakeLatest(),
 *     () => (context, { injected: { cancelToken }, jobId }) => {
 *       try {
 *         return getJob(jobId, cancelToken); // For details read Axios CancelToken API docs
 *       } catch (error) {
 *         if (isCancel(error)) {
 *           // Handle error here.
 *         }
 *       }
 *     }
 *   )(),
 *
 * @return {Function} - returns function which receives Vuex action.
 */
export const withTakeLatest = (cacheKey = 'bucketName') => (fn) => {
  const activeCancelSources = {};

  return (context, payload) => {
    const valueByCachedKey = payload[cacheKey];

    if (activeCancelSources[valueByCachedKey]) {
      activeCancelSources[valueByCachedKey].cancel('withTakeLatest has canceled previous request!');
    }

    activeCancelSources[valueByCachedKey] = CancelToken.source();

    return fn(context, {
      ...payload,
      injected: { ...payload.injected, cancelToken: activeCancelSources[valueByCachedKey].token },
    });
  };
};
